import type { SVGProps } from 'react';

export const ChargerSVG = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      stroke="currentColor"
      strokeWidth="0.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3776 4.01682C17.1684 3.6405 16.8347 3.33454 16.4241 3.14279C15.9574 2.9248 15.3464 2.9248 14.1245 2.9248H6.9245C5.70257 2.9248 5.0916 2.9248 4.62489 3.14279C4.21435 3.33454 3.88058 3.6405 3.6714 4.01682C3.43359 4.44465 3.43359 5.0047 3.43359 6.12481V19.7248C3.43359 20.8449 3.43359 21.405 3.6714 21.8328C3.88058 22.2091 4.21435 22.5151 4.62489 22.7068C5.0916 22.9248 5.70257 22.9248 6.9245 22.9248H14.1245C15.3464 22.9248 15.9574 22.9248 16.4241 22.7068C16.8347 22.5151 17.1684 22.2091 17.3776 21.8328C17.6154 21.405 17.6154 20.8449 17.6154 19.7248V6.1248C17.6154 5.0047 17.6154 4.44465 17.3776 4.01682ZM3.6714 21.8328L4.6434 21.3788C4.61592 21.3294 4.57482 21.2286 4.55061 20.957C4.52535 20.6736 4.5245 20.3014 4.5245 19.7248V6.12481C4.5245 5.54825 4.52535 5.17598 4.55061 4.89264C4.57482 4.62098 4.61592 4.52026 4.6434 4.47081C4.74799 4.28265 4.91488 4.12967 5.12015 4.0338C5.17409 4.00861 5.28396 3.97093 5.58032 3.94873C5.88942 3.92558 6.29553 3.9248 6.9245 3.9248H14.1245C14.7535 3.9248 15.1596 3.92558 15.4687 3.94873C15.765 3.97093 15.8749 4.00861 15.9289 4.0338C16.1341 4.12967 16.301 4.28265 16.4056 4.47081C16.4331 4.52026 16.4742 4.62098 16.4984 4.89264C16.5237 5.17598 16.5245 5.54825 16.5245 6.1248V19.7248C16.5245 20.3014 16.5237 20.6736 16.4984 20.957C16.4742 21.2286 16.4331 21.3294 16.4056 21.3788C16.301 21.567 16.1341 21.7199 15.9289 21.8158C15.8749 21.841 15.765 21.8787 15.4687 21.9009C15.1596 21.924 14.7535 21.9248 14.1245 21.9248H6.9245C6.29554 21.9248 5.88942 21.924 5.58032 21.9009C5.28396 21.8787 5.17409 21.841 5.12015 21.8158C4.91488 21.7199 4.74799 21.567 4.64341 21.3788L3.6714 21.8328Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.79794 6.9248V8.9248H13.2525V6.9248H7.79794ZM6.70703 5.9248H14.3434V9.9248H6.70703V5.9248Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.34277 22.9248V20.9248H18.7064V22.9248H2.34277Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7062 7.64641C18.7062 6.94821 19.467 6.46493 20.1802 6.71008L19.7971 7.64641V9.53452L21.1526 9.84516C21.6383 9.95645 21.979 10.3564 21.979 10.8153V12.9249H23.0699V8.77141L19.7971 7.64641L20.1802 6.71008L23.4529 7.83508C23.8787 7.98145 24.1608 8.35457 24.1608 8.77141V12.9249C24.1608 13.4772 23.6724 13.9249 23.0699 13.9249V18.9249C23.0699 19.4772 22.5815 19.9249 21.979 19.9249H20.8881C20.2856 19.9249 19.7971 19.4772 19.7971 18.9249V16.9249H16.5244V15.9249H19.7971C20.3996 15.9249 20.8881 16.3726 20.8881 16.9249V18.9249H21.979V13.9249C21.3765 13.9249 20.8881 13.4772 20.8881 12.9249L20.8881 10.8153L19.5326 10.5047C19.0469 10.3934 18.7062 9.99339 18.7062 9.53452V7.64641Z"
        fill="currentColor"
      />
      <path
        d="M8.34277 15.8623L12.3428 11.9248L11.3428 14.9873H13.3428L9.34277 18.9248L10.374 15.8623H8.34277Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2685 11.8613L12.4414 11.9521L11.4808 14.894H13.5784L9.41823 18.9891L9.24566 18.8976L10.236 15.9565H8.1084L12.2685 11.8613ZM8.57837 15.769H10.5132L9.57278 18.5618L13.1084 15.0815H11.206L12.1199 12.2828L8.57837 15.769Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0699 17.9248H18.1608C18.462 17.9248 18.7062 17.7009 18.7062 17.4248V15.4248C18.7062 15.1487 18.462 14.9248 18.1608 14.9248H17.0699C16.7686 14.9248 16.5244 15.1487 16.5244 15.4248V17.4248C16.5244 17.7009 16.7686 17.9248 17.0699 17.9248Z"
        fill="currentColor"
      />
    </svg>
  );
};
